// @ts-nocheck
import React, { useEffect } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FiltersConfigurator from './filters-configurator/filters-configurator';
import WidgetsConfigurator from './widgets-configurator/widgets-configurator';
import UserPreferenceService from '../../services/UserPreferenceService';

const userPreferenceService = new UserPreferenceService();

export default function WidgetsManagement() {
  const [value, setValue] = React.useState(0);

  useEffect(() => {
    const savedTab = userPreferenceService.get('ConfiguratorsMainTab');
    if (savedTab !== null) {
      setValue(savedTab);
    }
  }, []);

  useEffect(() => {
    userPreferenceService.save('ConfiguratorsMainTab', value);
  }, [value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="page-container">
      <h1 className="page-header">Widgets &amp; Filters</h1>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="manage-display-labels"
        indicatorColor="primary"
        textColor="primary"
        style={{ marginBottom: 24 }}
      >
        <Tab label="Customise Widgets" style={{ textTransform: 'none', fontWeight: 600, fontSize: 14 }} />
        <Tab label="Customise Filters" style={{ textTransform: 'none', fontWeight: 600, fontSize: 14 }} />
      </Tabs>
      {value === 0 && <WidgetsConfigurator />}
      {value === 1 && <FiltersConfigurator />}
    </div>
  );
}
